/**
 * UI State Slice
 * Manages UI-related state (sidebar, theme, notifications, etc.)
 */

export const createUISlice = (set, get) => ({
  // Sidebar state
  sidebarOpen: true,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),

  // Theme
  theme: 'light', // 'light' or 'dark'
  setTheme: (theme) => set({ theme }),

  // Notifications
  notifications: [],
  addNotification: (notification) =>
    set((state) => ({
      notifications: [...state.notifications, notification],
    })),
  removeNotification: (id) =>
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    })),
  clearNotifications: () => set({ notifications: [] }),

  // Loading states
  loading: false,
  setLoading: (loading) => set({ loading }),

  // Active tab/page
  activeTab: 'dashboard',
  setActiveTab: (tab) => set({ activeTab: tab }),
});






